import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 640 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M48 72c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24H216c-4.7 0-9.4 1.4-13.3 4L144 315.2V296c0-13.3-10.7-24-24-24H72c-13.3 0-24-10.7-24-24zM72 0C32.2 0 0 32.2 0 72v176c0 39.8 32.2 72 72 72h24v40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60H344c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72zm184 376c0 39.8 32.2 72 72 72h88.7l90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488v-40h24c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72H448v48h120c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24h-48c-13.3 0-24 10.7-24 24v19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4h-96c-13.3 0-24-10.7-24-24v-24h-48z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }